module.exports = __webpack_public_path__ + "img/10_of_Clubs.svg.476a7340.png";